/**
 * A module for merging default and site-specific configuration,
 * and retriving info from the config
 */

import { get } from "nested-property";
import merge from "lodash/merge";
import { logFeature } from "../../../scriptsCore/js/logging.js";
import { getCurrentScript } from "./utils.js";
const log = (...args) => logFeature("ads", ...args);

/**
 * deeply merge the default and site-specific configs
 */
function mergeConfigs(defaultCfg, siteCfg, ...otherCfgs) {
  // for non-chameleon sites (eg teamdogs) use bundled config json
  const cfg = Object.assign({}, defaultCfg);
  merge(cfg, siteCfg, ...otherCfgs);
  return cfg;
}

/**
 * Stash the assembled config into window.TMCONFIG,
 * to support legacy code that still uses this
 * @param {object} config
 */
function setGlobal(config) {
  window.TMCONFIG = config;
}

/**
 * Initializer for the config module
 * @param {*} defaultCfg
 * @param {*} siteCfg
 */
export function init(defaultCfg, siteCfg) {
  const currentScript = { currentScript: getCurrentScript().src };
  const cfg = mergeConfigs(defaultCfg, siteCfg, currentScript);
  setGlobal(cfg);
}

/**
 * Read some info from the config
 * @param {string} path Path to the required item in the config for example: "advertisingConfig.adUnitBaseName"
 */
export function readConfigPath(path) {
  const cfg = Object.assign({}, window.TMCONFIG);
  return get(cfg, path);
}

export function treeShakingCanary() {
  log("delete me");
}
